import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import View from './hosted-migration.presenter';
import {
  API_COMPLETE_HOSTED_MIGRATION_ENDPOINT,
  API_INITIATE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA,
} from '../../app-constants';
import { submitHMECustomerData } from './hosted-migration.actions';

// Reducer
export const hostedMigrationReducer = (state = {
  loading: false,
  data: {},
  dataLoaded: false,
  formSubmitted: false,
}, action) => {
  switch (action.type) {
    case API_COMPLETE_HOSTED_MIGRATION_ENDPOINT: {
      return {
        ...state,
        loading: false,
        data: action.data,
        dataLoaded: true,
      };
    }
    case API_INITIATE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA: {
      return {
        ...state,
        loading: true,
        dataLoaded: false,
        formSubmitted: false,
      };
    }
    case API_COMPLETE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA: {
      return {
        ...state,
        loading: false,
        dataLoaded: false,
        formSubmitted: true,
      };
    }
    default:
      return state;
  }
};


// Map & Connect
export const mapStateToProps = state => ({
  authorableContent: state.authorableContentReducer.authorableContent,
  customerEmailAddresses: state.hostedMigrationReducer.data.emailAddresses,
  userSubmitted: state.hostedMigrationReducer.data.userSubmitted,
  dataLoaded: state.hostedMigrationReducer.dataLoaded,
  formSubmitted: state.hostedMigrationReducer.formSubmitted,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    submitHMECustomerData,
  }, dispatch),
});

const HostedMigration = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

export default HostedMigration;
